import { ReactNode } from 'react';

type Variant = 'neutral' | 'success' | 'warning' | 'danger' | 'info';

export function Badge({ variant = 'neutral', children }: { variant?: Variant; children: ReactNode }) {
  const cls = variant === 'neutral' ? 'badge' : `badge ${variant}`;
  return <span className={cls}>{children}</span>;
}
